import React from "react";
import { Grid } from "@mui/material";
import FileUpload from "../../utils/FileUpload";
import bulk_Photo_upload from "../../assets/img/bulk_Photo_upload.png";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";
import {
  DownloadUsersTemplateService,
  uploadBulkUsersService,
  triggerPhotoService,
  DownloadPhotoErrorLogsService
} from "../../services/BulkUploadServices";
import download from "downloadjs";
import useGlobalState from "../../Context";

const BulkPhotosUpload = () => {
  const { setLoading } = useLoading();
  const { showNotification } = useNotificationContext();
  const [{ auth }] = useGlobalState();
  const loggedInUserId = auth.ldapParam.userId;

  const downloadErrorLogs = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("userId", JSON.stringify(loggedInUserId));
      const param = {
        userId: loggedInUserId,
      };
      const response = await DownloadPhotoErrorLogsService(formData);
      const content = response.headers["content-type"];
      download(response.data, "photoErrorLogs.csv", content);
    } catch (err) {
      showNotification("Error", "Failed To Fetch");
    } finally {
      setLoading(false);
    }
  };

  const downloadTemplate = async () => {
    try {
      setLoading(true);
      const response = await DownloadUsersTemplateService();
      const content = response.headers["content-type"];
      download(response.data, "UsersTemplate.csv", content);
    } catch (err) {
      showNotification("Error", "Failed To Fetch");
    } finally {
      setLoading(false);
    }
  };

  const onFileChange = (event) => {
    console.log("event", event)
    if (
      event.target.files[0]?.type === "text/csv" ||
      event.target.files[0]?.type === "application/vnd.ms-excel" ||
      event.target.files[0]?.type === "application/vnd.msexcel" ||
      event.target.files[0]?.type === "application/csv" ||
      event.target.files[0]?.type === "text/comma-separated-values"
    ) {
      if (event.target.files[0].size >= 10485760) {
        // allowing only file less than 10mbs
        showNotification(
          "Error",
          "File too Big, please select a file less than 10mb"
        );
      } else {
        uploadFile(event.target.files[0]);
        console.log("else if", event)
      }
    } else {
      console.log("else", event)
      showNotification("Error", "Invalid type selected, Please try again.");
    }
  };

  const uploadFile = async (file) => {
    const formData = new FormData();
    var createdBy = JSON.stringify(loggedInUserId);
    formData.append("file", file);
    formData.append("createdBy", createdBy);
    try {
      setLoading(true);
      const uploadResponse = await uploadBulkUsersService(formData);
      if (uploadResponse.messageCode === 200) {
        const response = uploadResponse.bulkParam;
        showNotification(
          "Upload Successful",
          `${response?.fileName} File Uploaded `,
          "success"
        );

      } else {

        showNotification("Error", uploadResponse.message);
      }
    } catch (err) {
      console.log('err in catch upload', err)
      showNotification("Error", "Failed To submit File");
    } finally {
      setLoading(false);
    }
  };

  const triggerPhotoUpload = async (e) => {
    try {
      setLoading(true);
      const requestBody = {
        uploadedBy: JSON.stringify(loggedInUserId)
      }
      const uploadResponse = await triggerPhotoService(requestBody);
      if (uploadResponse.statusCode === 6) {
        const response = uploadResponse;
        showNotification('success',
          uploadResponse.message,
          "success"
        );
      } else {

        showNotification("Error", uploadResponse.message);
      }
    } catch (err) {
      console.log('err in catch upload', err)
      showNotification("Error", "Failed To upload");
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      <Grid container spacing={0} sx={{ mt: 0, pb: 1,alignItems:"center" }}>
        <Grid item xs={3} sx={{ mt: "0" }}>
          <img src={bulk_Photo_upload} alt="User" width={50} />
        </Grid>
        <Grid item xs={4} sx={{ color: "#757575", fontSize: "16px", fontWeight: "500", mt: "0" }}>
          <p>Bulk Photos </p>
        </Grid>

        <Grid item xs={5} sx={{ mt: "0",textAlign:"left" }} >
          <FileUpload
            onFileChange={onFileChange}
            photoButton={true}
            showDownload={false}
            //download={downloadTemplate}
            downloadErrors={downloadErrorLogs}
            triggerPhotoUpload={triggerPhotoUpload}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default BulkPhotosUpload;
